import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { PAGE_SIZE } from 'util/config/constant';
import { BaseTable } from '../../../UI/BaseTable';
import { fetchNotificationOverviewList } from './state/operation';
import * as selector from './state/selector';
import {
  CUSTOM_PAGE_SIZE,
  STATE_PROP_NOTIFICATION,
  SEVERITIES
} from './util/constant';
import { renderColumns } from './util/render-columns';

export const NotificationOverview = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.OVERVIEW);
  const dispatch = useDispatch();
  const history = useHistory();

  const { notificationOverviewInfo } = useSelector((state) => ({
    notificationOverviewInfo: selector.selectNotificationOverviewListInfo(state)
  }));

  const columns = useMemo(() => {
    return renderColumns(t);
  }, [t]);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: CUSTOM_PAGE_SIZE,
    stateProp: STATE_PROP_NOTIFICATION
  });

  useEffect(() => {
    dispatch(
      fetchNotificationOverviewList({
        limit: pagination.limit,
        page: pagination.page
      })
    );
  }, [dispatch, pagination.limit, pagination.page]);

  const handlePageChange = (page) => {
    setPagination((currentPagination) => ({
      ...currentPagination,
      page
    }));
  };

  const handleOnRow = (columnData) => {
    return {
      onClick: () => {
        return history.push('/notifications', {
          currentExpandedRowId: columnData.id,
          severities: SEVERITIES,
          page: Math.round((pagination.page * pagination.limit) / PAGE_SIZE)
        });
      }
    };
  };

  const tableProps = useMemo(
    () => ({
      columns,
      loading: notificationOverviewInfo.isLoading,
      dataSource: notificationOverviewInfo.data,
      rowKey: 'id',
      pagination,
      onPageChange: handlePageChange,
      className: 'table-yellow-header widget-body',
      title: t('machinesRequiringAttentionTable.title')
    }),
    [
      columns,
      notificationOverviewInfo.data,
      notificationOverviewInfo.isLoading,
      pagination,
      t
    ]
  );

  return (
    <div className="notification-overview">
      <BaseTable {...tableProps} onRow={handleOnRow} />
    </div>
  );
};
